import normalizeUrl from 'normalize-url'

import errorTrackingService from 'utils/services/errorTrackingService'

export const getButtonUrl = (url: string) => {
  let result = '#'

  if (!url) {
    return result
  }

  try {
    result = normalizeUrl(url, { stripWWW: false })
  } catch (err) {
    errorTrackingService.trackWarning(err, {
      extra: { url },
      fingerprint: 'invalid-converted-url',
    })
  }

  return result
}
